import { isTesting, macroCondition } from '@embroider/macros';
import { createMemoryHistory, createBrowserHistory, type BrowserHistory } from 'history';
import { unstable_HistoryRouter as HistoryRouter, BrowserRouter } from 'react-router';

export const browserHistory: BrowserHistory = macroCondition(isTesting())
  ? createMemoryHistory()
  : createBrowserHistory();

export const ReactRouter = macroCondition(isTesting()) ? HistoryRouter : BrowserRouter;
